/**
 * Dynamic Hero – image fade-in on load (mirrors live theme images utility + _effects.scss).
 */

const SELECTOR_HERO_IMAGE = '.hero img.is-loading';

function revealHeroImage(img) {
  img.classList.remove('is-loading');
}

function initHeroImageFade(root = document) {
  root.querySelectorAll(SELECTOR_HERO_IMAGE).forEach((img) => {
    if (img.complete) {
      revealHeroImage(img);
      return;
    }

    img.addEventListener('load', () => revealHeroImage(img), { once: true });
    img.addEventListener('error', () => revealHeroImage(img), { once: true });
  });
}

function onSectionLoad(evt) {
  const target = evt?.target;
  if (!target?.querySelector?.('.hero')) return;
  initHeroImageFade(target);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initHeroImageFade());
} else {
  initHeroImageFade();
}

document.addEventListener('shopify:section:load', onSectionLoad);
